var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleAvatarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4991 15.924C16.1543 15.924 18.3068 13.7715 18.3068 11.1163C18.3068 8.46107 16.1543 6.30859 13.4991 6.30859C10.8439 6.30859 8.69141 8.46107 8.69141 11.1163C8.69141 13.7715 10.8439 15.924 13.4991 15.924Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28906 23.4214C6.14722 22.0127 7.35331 20.8485 8.79139 20.0408C10.2295 19.2329 11.8512 18.8086 13.5006 18.8086C15.15 18.8086 16.7717 19.2329 18.2098 20.0408C19.6479 20.8485 20.8539 22.0127 21.7122 23.4214",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 26.5C20.4037 26.5 26 20.9037 26 14C26 7.09644 20.4037 1.5 13.5 1.5C6.59644 1.5 1 7.09644 1 14C1 20.9037 6.59644 26.5 13.5 26.5Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAvatarOutlined);
export default __webpack_public_path__ + "static/media/circle-avatar-outlined.09e4b7f42701248cd061d3e618f5e76f.svg";
export { ForwardRef as ReactComponent };